import type {
	JSResourceLoader,
	JSResourceOptions,
	PreloadableJSResourceReference,
} from '../../types';
import { JSResource } from '../js-resource';

export function PreloadableJSResource<T>(
	loader: JSResourceLoader<T>,
	opts: JSResourceOptions,
): PreloadableJSResourceReference<T> {
	const resource = JSResource(loader, opts);
	return Object.assign(resource, {
		preload() {
			const jsModule = resource.getModuleIfRequired();
			if (jsModule != null) {
				return;
			}

			resource.load().catch(() => {});
		},
	});
}
